var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2GymStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1478_19938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1728 39.4321L48.1728 18.7552L50.7788 18.7124C52.0889 18.7124 53.221 19.2037 54.1751 20.1863C55.1292 21.1689 55.6063 22.3152 55.6063 23.6254L55.6063 34.6474C55.6063 35.9575 55.1292 37.0896 54.1751 38.0437C53.221 38.9978 52.0889 39.4749 50.7788 39.4749L48.1728 39.4321ZM7.11792 39.4749C5.80781 39.4749 4.6757 38.9978 3.7216 38.0437C2.7675 37.0896 2.29045 35.9575 2.29045 34.6474L2.29045 22.4292C2.29045 21.4608 2.65357 20.6135 3.37983 19.8873C4.10609 19.161 4.95339 18.7979 5.92174 18.7979L9.68118 18.7979L9.68119 39.4749H7.11792ZM13.3125 45.0713C12.7998 45.0713 12.3726 44.9004 12.0308 44.5587C11.6891 44.2169 11.5182 43.7897 11.5182 43.277L11.5182 14.9957C11.5182 14.483 11.6891 14.0558 12.0308 13.7141C12.3726 13.3723 12.7998 13.2014 13.3125 13.2014L21.2586 13.2014C21.7712 13.2014 22.1984 13.3723 22.5402 13.7141C22.882 14.0558 23.0529 14.483 23.0529 14.9957L23.0529 21.5747L34.8439 21.5747L34.8439 14.9957C34.8439 14.483 35.0148 14.0558 35.3565 13.7141C35.6983 13.3723 36.1255 13.2014 36.6382 13.2014L44.5416 13.1587C45.0542 13.1587 45.4885 13.3367 45.8445 13.6927C46.2006 14.0487 46.3786 14.483 46.3786 14.9957L46.3786 43.277C46.3786 43.7897 46.2006 44.224 45.8445 44.58C45.4885 44.936 45.0542 45.114 44.5416 45.114L36.6382 45.0713C36.1255 45.0713 35.6983 44.9004 35.3565 44.5587C35.0148 44.2169 34.8439 43.7897 34.8439 43.277L34.8439 36.698H23.0529L23.0529 43.277C23.0529 43.7897 22.882 44.2169 22.5402 44.5587C22.1985 44.9004 21.7712 45.0713 21.2586 45.0713H13.3125Z",
    fill: "#6b7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1478_19938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2GymStandard);
export default __webpack_public_path__ + "static/media/v2-gym-standard.ab3e6f5a2f27877443365f5856d7fba7.svg";
export { ForwardRef as ReactComponent };